/**
 * Which version of the game this page is. Each version keeps its own save and settings so
 * they can be played side by side. Set by `<html data-edition="…">` in each page.
 */
export type Edition = 'v2' | 'v3' | 'v4';

const raw = typeof document === 'undefined' ? undefined : document.documentElement.dataset.edition;
export const EDITION: Edition = raw === 'v3' || raw === 'v4' ? raw : 'v2';

/** Storage key namespaced to this edition, e.g. `integerney.v3.save`. */
export const storageKey = (name: string) => `integerney.${EDITION}.${name}`;
